<script>
import IntroService from '@/services/IntroService.js'
import MailService from '@/services/MailService.js'

const mail = new MailService();

export default {
	name: 'ContactView',
	data () {
		return {
			from: '',
			message: '',
			status: mail.status,
			intro: ''
		}
	},
	methods: {
		send: mail.send,
		reset: mail.reset
	},
	async mounted () {
		this.intro = await IntroService.getIntro();
	}
}
</script>
<template>

<div class="contact-view">

	<section class="contact">
		<h1>Prendre contact</h1>
		<form v-if="status.idle" @submit.prevent="send(from, message)">
			<input type="email" placeholder="mon adresse..." v-model="from">
			<textarea placeholder="un petit mot..." v-model="message"></textarea>
			<button type="submit" :disabled="!from || !message">... et c'est parti <i class="far fa-paper-plane" /></button>
		</form>
		<div v-if="status.loading" class="status">
			<i class="fas fa-cog fa-spin" />
		</div>
		<div v-if="status.success" class="status">
			<i class="fas fa-smile" />
			Bravo, votre message a été envoyé avec succès !
			<button @click="reset()">OK</button>
		</div>
		<div v-if="status.error" class="status">
			<i class="fas fa-meh" />
			Oups, votre message n'a pas pu être envoyé, désolé...
			<button @click="reset()">Réessayer</button>
		</div>
	</section>

	<section class="intro">
		<p v-for="(line, index) in intro" :key="index">{{ line }}</p>
	</section>

</div>

</template>
<style scoped>

	.contact {
		margin-bottom: 2em;
	}

	@media (min-width: 768px) {
        .contact {
			float: right;
			width: 40%;
            margin: 0 0 1em 2em;
        }
    }

	@media screen and (max-width: 425px) {
		.intro {
			padding: 0 1em;
		}
	}

	.contact {
		padding: 1.8em 2em;
		color: #EEE;
		background-color: rgba(255,255,255,.05);
		box-shadow: 0 4px 10px rgba(0,0,0,.1);
	}

	.intro {
		color: #EEE;
		text-align: justify;
	}

	h1 {
		margin: 0 0 .5em 0;
		white-space: nowrap;
		font: var(--app-font-header);
		font-size: 200%;
		color: #CCC;
	}

	input, textarea, button {
		display: block;
		border: none;
		background: none;
		color: inherit;
		padding: .8em;
		font: var(--app-font-title);
		font-size: 120%;
		border-radius: 3px;
	}

	input, textarea {
		width: 100%;
		margin-bottom: .4em;
		background-color: rgba(255,255,255,.05);
	}
	input::placeholder,
	textarea::placeholder {
		color: #888;
	}
	input:focus,
	textarea:focus {
		color: #000;
		background-color: rgba(255,255,255,.8);
		outline: none;
	}

	textarea {
		resize: vertical;
		min-height: 6em;
	}

	button {
		margin-left: auto;
		cursor: pointer;
	}
	button[disabled] {
		cursor: default;
		opacity: .3;
	}
	button:not([disabled]):hover,
	button:not([disabled]):focus {
		outline: none;
		background-color: #ff7f00;
	}
	button i {
		margin-left: .3em;
	}

	.status i {
		float: left;
		margin-right: .5em;
		font-size: 250%;
	}

</style>
